import monitoringDocumentController from "@/services/monitoringService";

export default {
  name: "PksView",

  data() {
    return {
      items: [],
      total: 0,
      page: 1,
      perPage: 10,
      perPageOptions: [10, 25, 50, 100],

      search: "",
      pksStatus: "",

      isLoading: false,
      searchTimer: null,
    };
  },

  computed: {
    totalPages() {
      return Math.ceil(this.total / this.perPage) || 1;
    },

    visiblePages() {
      const total = this.totalPages;
      const current = this.page;
      const delta = 2;
      const range = [];

      for (
        let i = Math.max(2, current - delta);
        i <= Math.min(total - 1, current + delta);
        i++
      ) {
        range.push(i);
      }

      if (current - delta > 2) range.unshift("...");
      if (current + delta < total - 1) range.push("...");

      range.unshift(1);
      if (total > 1) range.push(total);

      return range;
    },
  },

  methods: {
    async fetchData(page = 1) {
      if (page < 1 || page > this.totalPages) return;

      this.page = page;
      this.isLoading = true;

      try {
        const res = await monitoringDocumentController.getPks({
          pks_status: this.pksStatus || null,
          search: this.search,
          page: this.page,
          limit: this.perPage,
          // Urut berdasarkan transport offer yang paling baru dibuat
          // di atas (t.id DESC), bukan alfabetis nama perusahaan.
          sortBy: "transport_offer_id",
          sortDesc: "true",
        });

        this.items = res.data || [];
        this.total = res.total || 0;

        if (this.page > this.totalPages) {
          this.page = this.totalPages;
          await this.fetchData(this.page);
        }
      } catch (error) {
        console.error("Gagal memuat monitoring PKS:", error);
        this.items = [];
        this.total = 0;
      } finally {
        this.isLoading = false;
      }
    },

    onSearch() {
      if (this.searchTimer) clearTimeout(this.searchTimer);
      this.searchTimer = setTimeout(() => {
        this.fetchData(1);
      }, 400);
    },

    applyFilters() {
      this.fetchData(1);
    },

    changePerPage() {
      this.fetchData(1);
    },

    createPks(item) {
      this.$router.push({
        path: "/add-document",
        query: {
          transport_offer_id: item.transport_offer_id, // link SPH
          corporate_id: item.mst_corporate_id,
          from: this.$route.path,
          keterangan: "spk", // Surat Perintah Kerja (locked di form)
        },
      });
    },

    viewDocument(item) {
      this.$router.push({
        path: `/detail-document/${item.document_id}`,
        query: { from: this.$route.path },
      });
    },
  },

  beforeUnmount() {
    if (this.searchTimer) clearTimeout(this.searchTimer);
  },

  mounted() {
    this.fetchData(1);
  },
};
